import {fixNullString} from '../helpers/utils'
import App from '../app/App'
import {
  AP_ADDITIONAL_INFO_FORM_ALLOWED_SEGMENTS,
  AP_ANNUAL_SURVEY_ALLOWED_SEGMENTS,
  AP_OBNOVENI_KVALIFIKACE_SURVEY_ALLOWED_SEGMENTS,
  AP_PRVODARCE_SURVEY_ALLOWED_SEGMENTS,
  AP_REGISTRATION_SURVEY_ALLOWED_SEGMENTS
} from '../helpers/misc'
import Query from '../app/Query'

export class AccountResource {
  data = {
    pre_nominals: '',
    first_name: '',
    last_name: '',
    gender: '',
    birthdate: '',
    email: '',
    phone: '',
    address1: '',
    address2: '',
    address3: '',
    city: '',
    zip: '',
    country_code: '',
    photo_url: null,
    agreement_gtc: 0,
    agreement_profiling: 0,
    agreement_marketing_communication: 0,
    language_id: '',
    current_status: undefined,
    available_points: undefined,
    available_credits: undefined,
    address_types: [],
    addresses: [],
    properties: [],
    loading_error: false
  }

  constructor() {
    this.$app = App.instance
    this.$api = this.$app.$api
    this.$resource = this.$app.$resource

  }

  async getPersonalInfo(force = false) {

    try {

      const {personal_information} = await this.$app.$memory('personal-information', {
        action: 'carecloud_user_api',
        route: '?customer_short_salutation=true'
      }, force)

      const agreement_gtc = personal_information.agreement.agreement_gtc
      const agreement_mc = personal_information.agreement.agreement_marketing_communication
      const agreement_profiling = personal_information.agreement.agreement_profiling

      this.data = {
        ...this.data,
        salutation: personal_information.salutation,
        pre_nominals: personal_information.pre_nominals,
        first_name: personal_information.first_name,
        last_name: personal_information.last_name,
        gender: fixNullString(personal_information.gender),
        birthdate: personal_information.birthdate,
        email: personal_information.email,
        phone: personal_information.phone,
        street: personal_information.address.address1,
        descnumber: personal_information.address.address2,
        orientnumber: personal_information.address.address3,
        city: personal_information.address.city,
        zip: personal_information.address.zip,
        country_code: personal_information.address.country_code,
        photo_url: personal_information.photo_url,
        language_id: personal_information.language_id,
        loading_error: false,
        store_id: personal_information.store_id,
        agreement_gtc,
        agreement_mc,
        agreement_profiling
      }

      return this.data

    } catch (error) {

      //if(title)commit('setLoadingError', title)

      console.log(error)

    }

  }

  async isMandatoryDataRequired() {
    const {personal_information} = await this.$app.$memory('personal-information', {
      action: 'carecloud_user_api',
      route: '?customer_short_salutation=true'
    })

    return !personal_information.birthdate
  }

  async getStatus() {

    try {

      const {statuses = []} = await this.$resource('statuses', {
        action: 'carecloud_api',
        route: 'statuses'
      })

      const {status_records = []} = await this.$api({
        action: 'carecloud_user_api',
        route: 'status-records?valid_now=true'
      })

      const {status_id: current_status_id = 0} = (status_records.at(0) ?? {})
      const {name: status_name = 'Neznámý'} = (statuses.find(({status_id}) => status_id === current_status_id) ?? {})

      return status_name

    } catch (error) {

      console.log(error)

    }

  }

  getSurveySegmentsFromType(type) {
    switch (type) {
      case 'annual':
        return AP_ANNUAL_SURVEY_ALLOWED_SEGMENTS
      case 'registration':
        return AP_REGISTRATION_SURVEY_ALLOWED_SEGMENTS
      case 'guide':
        return null
      case 'prvodarce':
        return AP_PRVODARCE_SURVEY_ALLOWED_SEGMENTS
      case 'obnoveni_kvalifikace':
        return AP_OBNOVENI_KVALIFIKACE_SURVEY_ALLOWED_SEGMENTS
      default:
        return 'Dotazník'
    }
  }

  async isAllowedToShowSurvey(survey_type, segment_records = null) {
    const allowed_segments = this.getSurveySegmentsFromType(survey_type)

    if(segment_records === null)
      segment_records = (await this.$api({
        action: 'carecloud_user_api',
        route: 'segment-records'
      })).segment_records || []

    return segment_records.some(({segment_id}) => allowed_segments.includes(segment_id))
  }

  async isAllowedToShowRegistrationSurvey(segment_records = null) {
    return this.isAllowedToShowSurvey('registration', segment_records)
  }

  async isAllowedToShowAnnualSurvey(segment_records = null) {
    return this.isAllowedToShowSurvey('annual', segment_records)
  }

  async isAllowedToShowPrvodarceSurvey(segment_records = null) {
    return this.isAllowedToShowSurvey('prvodarce', segment_records)
  }

  async isAllowedToShowObnoveniKvalifikaceSurvey(segment_records = null) {
    return this.isAllowedToShowSurvey('obnoveni_kvalifikace', segment_records)
  }

  async isAllowedToShowAdditionalInfoForm(segment_records = null) {
    if(segment_records === null)
      segment_records = (await this.$api({
        action: 'carecloud_user_api',
        route: 'segment-records'
      })).segment_records || []

    return segment_records.some(({segment_id}) => AP_ADDITIONAL_INFO_FORM_ALLOWED_SEGMENTS.includes(segment_id))
  }

  async getPoints() {

    try {

      const {available_points = 0} = await this.$api({
        action: 'carecloud_api',
        route: `wallet/actions/points-overview`
      })

      return available_points

    } catch (error) {

      console.log(error)
      return 0

    }

  }

  async getCredits() {

    try {

      const {available_credits = 0} = await this.$api({
        action: 'carecloud_api',
        route: `wallet/actions/credits-overview`
      })

      return available_credits

    } catch (error) {

      console.log(error)
      return 0

    }

  }

  async getAddressTypes() {

    try {

      const {customer_address_types = []} = await this.$resource('customer-address-types', {
        action: 'carecloud_api',
        route: 'customer-address-types'
      })

      return customer_address_types

    } catch (error) {

      console.log(error)

    }

  }

  async getAddresses() {

    try {

      const {addresses = []} = await this.$api({
        action: 'carecloud_user_api',
        route: 'addresses'
      })

      return addresses

    } catch (error) {

      console.log(error)

    }

  }

  async getProperties() {

    try {

      const {property_records = []} = await this.$api({
        action: 'carecloud_user_api',
        route: 'property-records'
      })

      return property_records

    } catch (error) {

      console.log(error)

    }
  }

  async getStoreById(id) {
    if(!id) return

    try {

      return await this.$api({
        action: 'carecloud_api',
        route: `stores/${id}`
      })

    } catch (error) {

      console.log(error)

    }
  }

  async getLatestAndMostVisitedStore() {
    let blood_samples = await this.$app.$store('event').getBloodSampleEvents()

    const counts = {}

    blood_samples.events.forEach(event => {
      const omRecord = event.property_records.find(
        prop => prop.property_id === 'odberne_misto'
      )
      if(omRecord) {
        const id = omRecord.property_value
        counts[id] = (counts[id] || 0) + 1
      }
    })

    const sorted = Object.entries(counts)
      .sort((a, b) => b[1] - a[1])

    if(sorted.length === 0)
      return {
        mostVisitedStore: {name: '-', store_address: ''},
        latestVisitedStore: {name: '-', store_address: ''}
      }

    // MOST VISITED STORE
    let most_visited_store = await this.getStoreBySystemId(sorted[0][0])

    // LAST STORE
    const last_event_in_store = blood_samples?.events?.find(event => event.property_records?.some(prop => prop.property_id === 'odberne_misto'))
    let last_store_id = last_event_in_store?.property_records.find(prop => prop.property_id === 'odberne_misto')?.property_value || ''

    return {
      mostVisitedStore: most_visited_store,
      latestVisitedStore: (sorted[0][0] === last_store_id) ? most_visited_store : await this.getStoreBySystemId(last_store_id)
    }
  }

  async getStoreBySystemId(system_id) {
    let query = (new Query('stores'))
      .add('system_id', system_id).route

    const {stores} = await this.$api({
      action: 'carecloud_api',
      route: query
    })

    if(stores.length === 0)
      return null

    return stores[0]
  }

}